export const TOP_10_ORDERED = 'top_10_ordered'
export const TOP_10_RECENTLY = 'recently_purchased'
export const TOP_10_MOST = 'top_10_most_purchased'

export const TOP_10_ORDERED_NAME = 'ordered'
export const TOP_10_RECENTLY_NAME = 'recentlyPurchased'
export const TOP_10_MOST_NAME = 'mostPurchased'
